<header class="navbar">
  <div class="navbar__container">
    <div class="navbar__content">
      <!-- tengo la ruta online https://www.unipay.cl/assets/images/logo_unipay_white.png -->
      <a href="https://www.unipay.cl" class="navbar__logo">

        <img src="https://www.unipay.cl/api/descargaArchivo/logo_unipay_white002.png" alt="Unipay Logo"
          class="navbar__logo-image">
      </a>

      <!-- Desktop Navigation -->
      <nav class="navbar__nav">
        <div class="navbar__links">
          <a *ngFor="let link of getFilteredNavLinks()"
             (click)="navigateToLink(link)"
             class="navbar__link"
             [class.navbar__link--active]="isActive(link.href)"
             style="cursor: pointer;">
            {{ link.name }}
          </a>
        </div>
      </nav>

      <div class="navbar__actions">
        <a (click)="openAutoApertura()"
          class="navbar__button navbar__button--primary">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="navbar__icon">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          Solicitar Unipay
        </a>
        <a (click)="openPagoEstadoCuenta()" class="navbar__button navbar__button--secondary">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" stroke="currentColor" class="navbar__icon">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
          </svg>
          Pagar estado cuenta
        </a>
      </div>

      <!-- Mobile Navigation Toggle -->
      <button class="navbar__toggle" (click)="toggleMenu()"
        [attr.aria-label]="isMenuOpen ? 'Cerrar menú' : 'Abrir menú'" [attr.aria-expanded]="isMenuOpen">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="navbar__toggle-icon">
          <path d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7 128 544 142.3 544 160C544 177.7 529.7 192 512 192L128 192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3 512 96 497.7 96 480C96 462.3 110.3 448 128 448L512 448C529.7 448 544 462.3 544 480z"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Mobile Drawer + Overlay -->
  <div class="navbar__overlay" *ngIf="isMenuOpen" (click)="closeMenu()"></div>
  <aside class="navbar__drawer" [class.navbar__drawer--open]="isMenuOpen" [attr.aria-hidden]="!isMenuOpen">
    <div class="navbar__drawer-header">
      <a href="https://www.unipay.cl" class="navbar__logo" (click)="closeMenu()">
        <img width="100" src="assets/logo_black.png" alt="Unipay Logo" class="navbar__logo-image">
      </a>
      <button class="navbar__close" (click)="closeMenu()" aria-label="Cerrar menú">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="navbar__close-icon">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="navbar__drawer-actions">
      <a href="https://www.unipay.cl/autoatencion-ptoventa/validar-identidad?utm_source=Digital&utm_medium=Pagina_Unipay&utm_campaign=Boton" class="navbar__button navbar__button--primary" (click)="closeMenu()">
        Solicitar Unipay <img src="assets/dock.svg"  class="navbar__button-icon">
      </a>
      <!-- el siguietne ling es de fondo negro con texto blanco. -->
      <a href="https://www.unipay.cl/pago" class="navbar__button navbar__button--secondary" (click)="closeMenu()" style="background-color: black; color: white;">
        Pagar estado cuenta <img src="assets/dock.svg"  class="navbar__button-icon">
      </a>
    </div>
    <nav class="navbar__drawer-nav">
      <a *ngFor="let link of getFilteredNavLinks()"
         (click)="navigateToLink(link)"
         class="navbar__drawer-link"
         [class.navbar__drawer-link--active]="isActive(link.href)"
         style="cursor: pointer;">
                 <svg class="navbar__drawer-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
           <!-- Icono para Inicio -->
           <path *ngIf="link.name === 'Inicio'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
           <!-- Icono para ¿Qué es Unipay? - Tarjeta -->
           <path *ngIf="link.name === '¿Qué es Unipay?'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
           <!-- Icono para Beneficios -->
           <image *ngIf="link.name === 'Nueva App'" href="https://www.unipay.cl/api/descargaArchivo/appunimarc.svg" width="26" height="26" />
          
           <path *ngIf="link.name === 'Beneficios'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                       <!-- Icono para Productos - Icono de money-bills -->
            <image *ngIf="link.name === 'Productos'" href="assets/payments.svg" width="24" height="24" />
           <!-- Icono para Preguntas frecuentes -->
           <path *ngIf="link.name === 'Preguntas frecuentes'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
           <!-- Icono para Seguros
           <image *ngIf="link.name === 'Seguros'" href="assets/shield_seguros.svg" width="24" height="24" /> />-->
         </svg>
        {{ link.name }}
      </a>
    </nav>
  </aside>

  <!-- Botones flotantes que aparecen al hacer scroll -->

</header>
